<div
  class="image-div"
  appFileUploader
  (fileDropped)="onSelectedFile($event)"
  [class.is-file-available]="filePreviewURL"
  [style.height]="height"
>
  @if (processingImage) {
    <app-spinner diameter="30"></app-spinner>
  }

  @if (!filePreviewURL) {
    <div class="inside-div">
      <span>Drop file here</span>
      <span>or</span>
      <button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="processingImage">upload file</button>
    </div>
  }

  @if (filePreviewURL) {
    <img [src]="filePreviewURL" (error)="noImage()" (load)="loadingImage()" />
  }
</div>
@if (filePreviewURL) {
  <div>
    <button mat-button mat-stroked-button (click)="remove()" [disabled]="processingImage">Remove</button>
    <app-commit-button
      class="change"
      name="Change"
      [disabled]="processingImage"
      [buttonStatus]="buttonStatus"
      (commitButtonClicked)="fileInput.click()"
      [idleLabel]="'Change'"
    ></app-commit-button>
  </div>
}

@if (errorMessage) {
  <app-error-message [errorMessage]="errorMessage"></app-error-message>
}

<input type="file" class="hidden" (change)="onSelectedFile($event.target.files)" [accept]="acceptFileFormat" #fileInput />
